module.exports = __webpack_public_path__ + "img/usdt_logo.2aa5d163.png";